import { render, staticRenderFns } from "./StudentGrades.vue?vue&type=template&id=53c979ea&scoped=true"
import script from "./StudentGrades.vue?vue&type=script&lang=js"
export * from "./StudentGrades.vue?vue&type=script&lang=js"
import style0 from "./StudentGrades.vue?vue&type=style&index=0&id=53c979ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c979ea",
  null
  
)

export default component.exports